import { ISiteDTO } from "@/Administration/Api/Dto/Sites/ISiteDTO";
import { SiteCreateModel } from "@/Administration/Models/UI/Sites/ISiteCreateModel";
import { AdministrationStore } from "@/Administration/Stores/AdministrationStore";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IClinicLogo } from "@/Common/Models/Sites/IClinicLogo";
import { Site } from "@/Common/Models/Sites/ResponseModels/Site";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { SitesUIState } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class SitesTabHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Sites.LoadSites, this.loadSites);
        this.RegisterOperation(LocalOperations.Sites.OpenSelectedSite, this.openSelectedSite);
        this.RegisterOperation(LocalOperations.Sites.AddNewSite, this.addNewSite);
        this.RegisterOperation(LocalOperations.Sites.SaveSite, this.saveSite);
        this.RegisterOperation(LocalOperations.Sites.ModifySite, this.modifySite);
        this.RegisterOperation(LocalOperations.Sites.CancelSite, this.cancelSite);
        this.RegisterOperation(LocalOperations.Sites.AddOrganization, this.addOrganization);
        this.RegisterOperation(LocalOperations.Sites.CloseDuplicatePopup, this.closeDuplicatePopup);
        this.RegisterOperation(LocalOperations.Sites.ProceedClick, this.proceedClick);
        this.RegisterOperation(LocalOperations.Sites.SaveLogo, this.saveLogo);
    }

    private loadSites(request: LocalEvent, store: AdministrationStore): void {
        store.sitesTabModel = store.sitesTabModel.set("SearchText", request.Get<string>("value"));

        store.sitesTabAction.loadSites();
    }

    private openSelectedSite(request: LocalEvent, store: AdministrationStore): void {
        let site = request.Get<SitesModel>("site");
        store.sitesTabModel = store.sitesTabModel.set("UIStateChange", SitesUIState.View);
        store.siteViewModel = store.siteViewModel.set("Model", MyleHelper.CloneObject(site.Model));

        store.sitesTabAction.getCostCenters(site.Model.Id);
    }

    private addNewSite(request: LocalEvent, store: AdministrationStore): void {
        store.siteCreateModel = SiteCreateModel.getDefault();

        store.siteCreateModel = store.siteCreateModel.set("ParentSites", store.sitesTabModel.get("ParentSites"));
        store.siteCreateModel = store.siteCreateModel.set("IsOrganization", false);
        store.siteCreateModel = store.siteCreateModel.set("Title", "AddNewSiteLabel");
        store.siteCreateModel = store.siteCreateModel.set("InfoLabel", "SiteInfoLabel");
        store.siteCreateModel = store.siteCreateModel.set("Model", new Site());
        store.siteCreateModel = store.siteCreateModel.set("Id", "site_id_" + sessionStore.newId());

        store.sitesTabModel = store.sitesTabModel.set("UIStateChange", SitesUIState.Create);
    }

    private saveSite(request: LocalEvent, store: AdministrationStore): void {
        store.sitesTabAction.saveSite(request.Get<ISiteDTO>("dto"), false);
    }

    private saveLogo(request: LocalEvent, store: AdministrationStore): void {
        store.sitesTabAction.saveLogo(request.Get<IClinicLogo[]>("logoAttachments"), request.Get<string>("siteId"), request.Get<boolean>("forAllSites"));
    }

    private modifySite(request: LocalEvent, store: AdministrationStore): void {
        store.siteCreateModel = store.siteCreateModel.set("Model", MyleHelper.CloneObject(store.siteViewModel.get("Model")));
        store.siteCreateModel = store.siteCreateModel.set("ParentSites", store.sitesTabModel.get("ParentSites"));

        store.siteCreateModel = store.siteCreateModel.set("IsOrganization", IsNullOrWhiteSpace(store.siteViewModel.get("Model").ParentSiteId));

        store.siteCreateModel = store.siteCreateModel.set(
            "Title",
            IsNullOrWhiteSpace(store.siteViewModel.get("Model").ParentSiteId)
                ? "ModifyOrganizationLabel"
                : "ModifySiteLabel"
        );
        store.siteCreateModel = store.siteCreateModel.set(
            "InfoLabel",
            IsNullOrWhiteSpace(store.siteViewModel.get("Model").ParentSiteId)
                ? "OrganizationInfoLabel"
                : "SiteInfoLabel"
        );

        store.sitesTabModel = store.sitesTabModel.set("UIStateChange", SitesUIState.Create);
    }

    private cancelSite(request: LocalEvent, store: AdministrationStore): void {
        let site = request.Get<Site>("site");

        store.siteViewModel = store.siteViewModel.set("Model", site);
        store.sitesTabModel = store.sitesTabModel.set("UIStateChange", SitesUIState.View);
    }

    private addOrganization(request: LocalEvent, store: AdministrationStore): void {
        store.siteCreateModel = SiteCreateModel.getDefault();
        store.siteCreateModel = store.siteCreateModel.set("ParentSites", store.sitesTabModel.get("ParentSites"));
        store.siteCreateModel = store.siteCreateModel.set("IsOrganization", true);
        store.siteCreateModel = store.siteCreateModel.set("Title", "AddOrganizationLabel");
        store.siteCreateModel = store.siteCreateModel.set("InfoLabel", "OrganizationInfoLabel");

        store.sitesTabModel = store.sitesTabModel.set("UIStateChange", SitesUIState.Create);
    }

    private closeDuplicatePopup(request: LocalEvent, store: AdministrationStore): void {
        store.sitesTabModel = store.sitesTabModel.set("IsDuplicateWarningOpen", false);
        sessionStore.hideGlobalOverlay();
    }

    private proceedClick(request: LocalEvent, store: AdministrationStore): void {
        store.sitesTabAction.saveSite(store.sitesTabModel.get("DuplicateDto"), true);

        store.sitesTabModel = store.sitesTabModel.set("IsDuplicateWarningOpen", false);
        sessionStore.hideGlobalOverlay();
    }
}

export { SitesTabHandler };
